export const GET_ACCESS_REQUEST_INITIAL_DATA = 'GET_ACCESS_REQUEST_INITIAL_DATA';
export const GET_ACCESS_REQUEST_INITIAL_DATA_SUCCESS = `${GET_ACCESS_REQUEST_INITIAL_DATA}/SUCCESS`;
export const GET_ACCESS_REQUEST_INITIAL_DATA_FAILURE = `${GET_ACCESS_REQUEST_INITIAL_DATA}/FAILURE`;

export const NEW_ACCESS_REQUEST = 'NEW_ACCESS_REQUEST';
export const NEW_ACCESS_REQUEST_SUCCESS = `${NEW_ACCESS_REQUEST}/SUCCESS`;
export const NEW_ACCESS_REQUEST_FAILURE = `${NEW_ACCESS_REQUEST}/FAILURE`;

export default {
  GET_ACCESS_REQUEST_INITIAL_DATA,
  GET_ACCESS_REQUEST_INITIAL_DATA_SUCCESS,
  GET_ACCESS_REQUEST_INITIAL_DATA_FAILURE,

  NEW_ACCESS_REQUEST,
  NEW_ACCESS_REQUEST_SUCCESS,
  NEW_ACCESS_REQUEST_FAILURE
};
